export const NEXT_STEP = 'wizard.NEXT_STEP';
export const PREV_STEP = 'wizard.PREV_STEP';
export const GO_TO_STEP = 'wizard.GO_TO_STEP';
export const INITIALISED = 'wizard.INITIALISED';
export const ADD_STEP = 'wizard.ADD_STEP';
export const FORWARD = 'wizard.FORWARD';
export const BACKWARD = 'wizard.BACKWARD';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const IN_IT_SLIDER = 'IN_IT_SLIDER';
export const MAKE_DIRTY = 'wizard.MAKE_DIRTY';
export const MAKE_ERROR = 'wizard.MAKE_ERROR';
export const MAKE_VALID = 'wizard.MAKE_VALID';
export const FORM_SAVING = 'wizard.FORM_SAVING';
export const VISITED_STEP = 'wizard.VISITED_STEP';
export const PROGRESS_INDICATORS = 'wizard.PROGRESS_INDICATORS';
export const INIT_STEPS = 'wizard.INIT_STEPS';
export const LENGTH_OF_FILE_NAME = 'wizard.LENGTH_OF_FILE_NAME';
export const CLEAR_STEPS = 'wizard.CLEAR_STEPS';
export const RESET_CURRENT_STEP = 'wizard.RESET_CURRENT_STEP';



// WEBPACK FOOTER //
// ./app/containers/Wizard/constants.js